import { API } from "@/constants/common";

export default class PowerBiServices {
  public static async getAllWorkSpace() {
    const response = await fetch(`${API.SERVER.POWER_BI.WORKSPACE}`);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(`Failed to fetch Power BI workspaces: ${error.message}`);
    }
    const data = await response.json();
    return data.value || data;
  }

  public static async getAllPowerBI(workspaceId: string | null) {
    if (!workspaceId) return;
    const response = await fetch(`${API.SERVER.POWER_BI.REPORT}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ workspaceId }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(`Failed to fetch Power BI reports: ${error.message}`);
    }
    const data = await response.json();
    return data.value || data;
  }

  public static async getTokenPowerBi(
    workspaceId: string | undefined,
    powerBiId: string | undefined,
    body: any
  ) {
    if (!workspaceId || !powerBiId) return;
    const response = await fetch(`${API.SERVER.POWER_BI.TOKEN}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ workspaceId, powerBiId, body }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(`Failed to fetch Power BI reports: ${error.message}`);
    }
    const data = await response.json();
    return data.value || data;
  }
}
